import { parseIntOrNaN } from '@office-start/config-query-wrapper-service';
export function resolveSharedContext(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var featureSettings = _a.featureSettings, userEntitlements = _a.userEntitlements, componentContext = _a.componentContext;
    // FeatureSettings parsing
    var graphApiRoot = (_c = (_b = featureSettings.resources) === null || _b === void 0 ? void 0 : _b.graph) !== null && _c !== void 0 ? _c : '';
    var iceApplicationId = parseIntOrNaN((_e = (_d = featureSettings.sharedContext) === null || _d === void 0 ? void 0 : _d.iceApplicationId) !== null && _e !== void 0 ? _e : '-1');
    var recommendedIceApplicationId = parseIntOrNaN((_g = (_f = featureSettings.authModel) === null || _f === void 0 ? void 0 : _f.recommendedIceApplicationId) !== null && _g !== void 0 ? _g : '-1');
    var supportDocsUrl = (_j = (_h = featureSettings.sharedContext) === null || _h === void 0 ? void 0 : _h.supportDocsUrl) !== null && _j !== void 0 ? _j : '';
    var teamsUrl = (_l = (_k = featureSettings.sharedContext) === null || _k === void 0 ? void 0 : _k.teamsUrl) !== null && _l !== void 0 ? _l : '';
    // Context parsing
    var officeMarketLcid = componentContext.officeMarketLcid;
    // UserEntitlements parsing
    var oneDriveResourceId = (_m = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.OneDriveResourceId) !== null && _m !== void 0 ? _m : '';
    var sharePointResourceId = (_o = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.SharePointResourceId) !== null && _o !== void 0 ? _o : '';
    return {
        graphApiRoot: graphApiRoot,
        iceApplicationId: iceApplicationId,
        officeMarketLcid: officeMarketLcid,
        oneDriveResourceId: oneDriveResourceId,
        recommendedIceApplicationId: recommendedIceApplicationId,
        sharePointResourceId: sharePointResourceId,
        supportDocsUrl: supportDocsUrl,
        teamsUrl: teamsUrl,
    };
}
//# sourceMappingURL=resolveSharedContext.js.map